/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.DisconnectPolicy
*/
export var DisconnectPolicy;
(function (DisconnectPolicy) {
    DisconnectPolicy["SUSPEND"] = "SUSPEND";
    DisconnectPolicy["KEEP_OPEN"] = "KEEP_OPEN";
    DisconnectPolicy["CLOSE"] = "CLOSE";
})(DisconnectPolicy || (DisconnectPolicy = {}));
//# sourceMappingURL=DisconnectPolicy.js.map